import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'returnGridTemplate',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      cancelaRetorno: false,
      retonarGrid: false
    }
  },

  props: [],

  watch: {
  },

  mounted () {
  },
  methods: {
    cancel () {
      this.cancelaRetorno = !this.cancelaRetorno
      this.$emit('cancelaRetorno', this.cancelaRetorno)
    },
    retonar () {
      this.retonarGrid = !this.retonarGrid
      this.$emit('retonar', this.retonarGrid)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/returnGridTemplate/returnGridTemplate.js